import { render, staticRenderFns } from "./MatchedPatientCard.vue?vue&type=template&id=07d8ebcb&scoped=true&"
import script from "./MatchedPatientCard.vue?vue&type=script&lang=js&"
export * from "./MatchedPatientCard.vue?vue&type=script&lang=js&"
import style0 from "./MatchedPatientCard.vue?vue&type=style&index=0&id=07d8ebcb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07d8ebcb",
  null
  
)

export default component.exports